import React from "react";

const Button = ({
  children,
  variant = "primary",
  size = "md",
  type = "button",
  id = "",
  disabled = false,
  className = "",
  onClick,
}) => {
  const sizeClass = size === "sm" ? "btn-sm" : size === "lg" ? "btn-lg" : "";

  return (
    <button
      type={type}
      id={id}
      className={`btn btn-${variant} ${sizeClass} ${className}`}
      style={{ borderRadius: "0.5rem" }}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;
